import { html, LitElement, unsafeCSS } from 'lit';
import { property } from 'lit/decorators/property.js';
import { customElement } from 'lit/decorators/custom-element.js';
import {
    Pagination,
    PaginationInterface
} from '../../library/class/pagination.ts';
import {
    Filters,
    FiltersInterface
} from '../../library/class/filters.class.ts';
import resultListCSS from './bg-result-list.scss?inline';
import { SlCard } from '@shoelace-style/shoelace';
import { classMap } from 'lit/directives/class-map.js';

// Important! "shoelaceElementFactory" is used to announce the use of Shoelace components
// @ts-ignore
const shoelaceElementFactory = (tagName: string) => {
    // Define a list of all Shoelace components being used
    customElements.define(tagName, SlCard);
};

export interface BgResultListInterface {
    pagination?: PaginationInterface;
    filters?: FiltersInterface;
}

/**
 * BgResultList
 */
@customElement('bg-result-list')
export class BgResultList extends LitElement {
    @property()
    docsHint = '';

    @property({ type: Object })
    pagination?: PaginationInterface = undefined;

    @property({ type: Object })
    filters?: FiltersInterface = undefined;

    constructor(args: BgResultListInterface) {
        super();
        
        if (!args) {
            return;
        }
        
        this.pagination = args.pagination;
        this.filters = args.filters;
    }

    private _pagination?: Pagination;
    private _filters?: Filters;

    render = () => {
        const filtersURL = getFiltersFromUrl();
        this._pagination = new Pagination(this.pagination, filtersURL);
        this._filters = new Filters(this.filters);
        const filters = this._filters.renderFilters();
        const pagination = this._pagination?.renderPagination() || '';
        const classMapping = {
            'bg-result-list': true
        };
        
        return html`
            ${filters}
            <div class="${classMap(classMapping)}">
                <slot></slot>
            </div>
            ${pagination}
            <style>
                .bg-result-list {
                    color: var(--bg-color-foreground);
                    ${this.style}
                }
            </style>
        `;
    };

    static styles = unsafeCSS(resultListCSS);

    /* Start manage event when selecting a value from the dropdown */
    firstUpdated = () => {
        const filterDropdown = this.shadowRoot?.querySelector('sl-dropdown');
        if (!filterDropdown) {
            return;
        }

        filterDropdown.addEventListener('sl-select', (event) => {
            const selectedItem = event.detail.item;
            window.top?.location.assign(selectedItem.value);
        });
    };
    /* End manage event when selecting a value from the dropdown */
}

declare global {
    interface HTMLElementTagNameMap {
        'bg-result-list': BgResultList;
    }
}

function getFiltersFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const filter = urlParams.get('filter');
    return filter ? `&filter=${filter}` : '';

}

